import React, { Component } from "react";
import HomeComponent from './../components/HomeComponent';
import Landing from './../../landing/containers/LandingContainer';


import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './../../Actions/Dashboard';



class HomeContainer extends Component {

  onChangeRoute = (route) => {
    this.props.actions.activePage(route);
    this.props.history.push(route);
  }
  render() {
    return (
      <Landing history={this.props.history} hasFooter={false}>
        <HomeComponent onChangeRoute={this.onChangeRoute} session={this.props.session} />
      </Landing>
    );
  }
}

function mapStateToProprs(state) {
  return {
    session: state.session,
  };
}


function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  }
}

export default connect(mapStateToProprs, mapDispatchToProps)(HomeContainer);